module.exports = __webpack_public_path__ + "static/img/zhanguanpingmianico.ffd74c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zhanguanpingmianico.png
// module id = Nlxq
// module chunks = 1